/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_ErrorInputs */



/**
* | output |
* | --- |
* | "An error occurred during login. Please try again." |
*
* @param {Auth_Login_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_login_error = /** @type {((inputs?: Auth_Login_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Während der Anmeldung ist ein Fehler aufgetreten. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("An error occurred during login. Please try again.")
});